import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'not-found-layout',
  },
})
export class NotFoundComponent {
  constructor() {}
}
